import { render, staticRenderFns } from "./ImportContentChainModal.vue?vue&type=template&id=0a2d4f74&scoped=true&"
import script from "./ImportContentChainModal.vue?vue&type=script&lang=js&"
export * from "./ImportContentChainModal.vue?vue&type=script&lang=js&"
import style0 from "./ImportContentChainModal.vue?vue&type=style&index=0&id=0a2d4f74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2d4f74",
  null
  
)

export default component.exports